import React from 'react';

import { Group, Stack, Text, ThemeIcon, Title, useMantineTheme } from '@mantine/core';
import { IconCalendar, IconCalendarSearch, IconTrendingUp } from '@tabler/icons-react';

const RevenueProjectionEmptyState = (): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Stack mt='xl' pt='xl' spacing='xl' p='md' justify='center' align='center'>
      <Stack maw='349px' align={'center'}>
        <IconCalendarSearch size={64} color={theme.colors.kiloBlue[5]} strokeWidth={1.5} />

        <Title order={2} fw={600} ta='center' mt='xl'>
          Ready to Calculate Your Projected Revenue
        </Title>
        <Text c='dimmed' align='center'>
          Select your{' '}
          <Text span fw={600} color='kiloBlue'>
            Future Dates
          </Text>{' '}
          to calculate your projected revenue based on existing invoices, auto-renew packages and projections
        </Text>

        <Group position='apart' spacing='xl' my='xl'>
          <Group>
            <ThemeIcon radius='xl' size='24px' variant='light' color='green'>
              <IconCalendar />
            </ThemeIcon>
            <Text>Pick Dates</Text>
          </Group>
          <Group>
            <ThemeIcon radius='xl' size='24px' variant='light' color='green'>
              <IconTrendingUp />
            </ThemeIcon>
            <Text>View Projections</Text>
          </Group>
        </Group>
      </Stack>
    </Stack>
  );
};

export default RevenueProjectionEmptyState;
